// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.month-picker-month-table .ui-button{\n  width: 4.3em !important;\n}\n", ""]);
// Exports
module.exports = exports;
